
<div class="step-hours-cont">
  <el-skeleton :loading=isLoadingTabs animated class="hours-grid-cont">
    <template slot="template">
      <div class="button-group">
        <el-skeleton-item class="label-loading" />
        <div class="step-hours-button-cont">
          <el-skeleton-item class="hours-loading" animated v-for="n in 8" :key="n" />
        </div>
      </div>
    </template>
    <template>
      <div v-if="getAvailableTabs !== null" class="step-hours-selection-cont">
        <div class="button-group" v-for="services in getAvailableTabs" :key="services.name" :label="services.name"
          v-if="services.tabs.length > 0">
          <div v-if="services.type === 'event'" class="step-hours-label">{{ services.title }}</div>
          <div class="step-hours-button-cont">
            <el-tooltip v-for="tab in services.tabs" :key="tab.hour"
              :content="!tab.available ? `${tab.capacity} place${tab.capacity > 0 ? 's' : ''} disponible${tab.capacity > 0 ? 's' : ''}` : ''"
              placement="top" :disabled="tab.available">
              <el-button :disabled="!tab.available" :label="tab.hour" :value="tab.hour" class="step-hours-button"
                @click="selectService({
                  hour: tab.hour,
                  serviceName: services.name,
                  cashOn: services.cashOn,
                  cashPrice: services.cashPrice,
                  cashCouv: services.cashCouv,
                  cashType: services.cashType,
                  discount: tab.discount,
                })">
                <div class="step-hours-button-hour">
                  {{ tab.hour }}
                </div>
                <div v-if="tab.discount" class="discount-badge">
                  <p>
                    -{{ tab.discount }}%
                  </p>
                </div>
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </template>
  </el-skeleton>
</div>
